/* ¿El chofer es de larga distancia o de movimientos?
 *
 * ── EL DATO NO EXISTÍA, Y ESO DEFINE CÓMO SE HACE ─────────────────────────
 *
 * Se buscó antes de crear la columna: de los **224 choferes, 2** traen
 * «(MOV.)» adentro del nombre y **ninguno** dice LARGA. No hay de dónde
 * deducirlo — lo rellena Marcos, con la carga en tanda.
 *
 * ── VA COMO COLUMNA Y NO COMO MARCA EN EL NOMBRE ─────────────────────────
 *
 * Es el camino que ya recorrió `requiere_peligrosas`: era «(P)» escrito
 * adentro del nombre y hoy es una columna. No se repite el patrón viejo, que
 * obliga a parsear un nombre para saber un atributo.
 *
 * Y hay una razón más fuerte, que se descubrió al hacer esto: **el sync de las
 * 03:50 pisa `requiere_peligrosas` sin `coalesce`**, porque lo deriva del
 * nombre de la planilla. O sea que lo que se cargue a mano en esa columna se
 * borra esa misma noche. `tipo_servicio` no está en el `on conflict` del
 * volcado, así que lo que se escribe queda.
 *
 * ── TRES ESTADOS, Y EL TERCERO ES EL DE TODOS EL PRIMER DÍA ──────────────
 *
 * Los 224 arrancan en «sin dato». Dibujado igual que «movimientos», la lista
 * de larga distancia arrancaría vacía y el trabajo de cargarlos no se vería
 * nunca. Es la misma regla de la lona, del psicofísico sin fecha y de las 86
 * unidades que no reportaron urea: **«no sabemos» no se dice como «no»**.
 */

export const LARGA = "larga";
export const MOV = "mov";
export const SIN_DATO = "sin_dato";

/* `sin_dato` va ÚLTIMO en las opciones —no es algo que alguien elija, es el
 * estado en el que están— y es el que se cuenta como pendiente. */
export const TIPOS = [
  { clave: LARGA, etiqueta: "Larga distancia", corto: "Larga" },
  { clave: MOV, etiqueta: "Movimientos", corto: "Mov." },
  { clave: SIN_DATO, etiqueta: "Sin dato", corto: "—" },
];

/* De lo que hay en la fila al estado. Acepta las formas en que puede llegar
 * escrito —incluida la marca «(MOV.)» que hoy vive en 2 nombres— para que esos
 * dos no se pierdan el día que alguien los migre. */
export function tipoDe(valor) {
  const v = String(valor ?? "").trim().toLowerCase();
  if (!v) return SIN_DATO;
  if (v === LARGA || v.startsWith("larga") || v === "ld") return LARGA;
  if (v === MOV || v.startsWith("mov")) return MOV;
  return SIN_DATO;
}

export function etiquetaTipo(valor) {
  const t = TIPOS.find((x) => x.clave === tipoDe(valor));
  return t ? t.etiqueta : "Sin dato";
}

/* Cuántos de cada uno, con los que faltan aparte.
 *
 * DEVUELVE `faltan` POR SEPARADO: «12 de larga distancia» sobre 224 se lee como
 * un inventario terminado, y con «y 200 sin cargar» al lado se lee como lo que
 * es. Misma regla que la lona y que la cobertura del historial de AdBlue. */
export function contar(filas) {
  const out = { [LARGA]: 0, [MOV]: 0, [SIN_DATO]: 0 };
  for (const f of filas || []) out[tipoDe(f?.tipo_servicio)] += 1;
  return { ...out, total: (filas || []).length, faltan: out[SIN_DATO] };
}
